import { JSEncrypt } from 'js-encrypt';

// 公钥
const PublicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCaC0Eidrn1AovUPXH29KplykEErfz0Z8e99zqNrMRmMOv8V8FqvLKjaB7S4wU+mlzX2oNomnyif0r8ZulelrzrMIDzHZIekIxq2/dBY453zt2BLExeqKF+58g/UAg5uLfThUHVa5PvsU1WOiCq8XANCA5nab9GOniB7Bb2gMhP+QIDAQAB';

/**
 * RSA加密
 * @author iori
 * @param str 输入的内容
 * @returns {string} RSA加密后的内容
 */
export function encrypt2RSA(str) {
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(PublicKey);
    return encrypt.encrypt(str);
}
